export const checkMaxNumberOfTabs = (state, newTab) => {
    if (!state.root.appSettings.StaticData)
        return true;
    const limitPatientTabs = state.root.appSettings.StaticData.LimitPatientTabs;
    const limitNonPatientTabs = state.root.appSettings.StaticData.LimitNonPatientTabs;
    if (!limitPatientTabs || !limitNonPatientTabs)
        return true;
    const dockable = (state.root.appSettings.StaticData?.DockableMenuItems || []).includes(newTab.ID);
    if (dockable)
        return true;
    const maxNumberOfTabs = newTab.IsPatientSpecific ? limitPatientTabs : limitNonPatientTabs;
    let currentNumberOfTabs = Object.values(state.root.tabs).filter((tab) => {
        //Locked tabs are ignored
        if (tab.locked)
            return false;
        //Dockable tabs are ignored
        let dockable = tab.menuId && (state.root.appSettings.StaticData?.DockableMenuItems || []).includes(tab.menuId);
        if (dockable)
            return false;
        let menuItem = tab.menuId && state.root.appSettings.StaticData.MenuItems[tab.menuId] || {};
        return menuItem.IsPatientSpecific === newTab.IsPatientSpecific;
    }).length;
    if (maxNumberOfTabs &&
        maxNumberOfTabs > 0 &&
        currentNumberOfTabs >= maxNumberOfTabs) {
        window.DialogManager.GlobalDialog.alert("Maximum number of tabs reached", `The maximum number of ${maxNumberOfTabs} ${newTab.IsPatientSpecific == null
            ? ""
            : newTab.IsPatientSpecific
                ? "patient"
                : "non-patient"} tabs has been reached. ` +
            "Please close at least 1 tab before selecting from the menu.");
        return false;
    }
    return true;
};
